import type { AgentActivity, AgentSdk } from "@/sdk";

// Tried in order; first match in the SDK's runtime activity list wins.
const PREFERRED_SAFE_FALLBACK_ACTIVITIES: readonly AgentActivity[] = [
    "Coaching" as AgentActivity,
    "Break" as AgentActivity,
];

export function resolveNonRoutableTarget(
    sdk: AgentSdk,
    logOutOnOfflineAgentActivity: boolean,
): AgentActivity | undefined {
    const safe = findSafeNonRoutableActivity(sdk);
    if (safe) return safe;

    const fallback = sdk.defaultAgentActivity ?? sdk.offlineAgentActivity;
    if (fallback === sdk.offlineAgentActivity && logOutOnOfflineAgentActivity) return undefined;

    return fallback;
}

function findSafeNonRoutableActivity(sdk: AgentSdk): AgentActivity | undefined {
    const candidates = sdk.agentActivities.filter(
        (a) => a !== sdk.availableAgentActivity && a !== sdk.offlineAgentActivity && sdk.isAgentActivitySelectable(a),
    );

    for (const preferred of PREFERRED_SAFE_FALLBACK_ACTIVITIES) {
        if (candidates.includes(preferred)) return preferred;
    }

    return candidates[0];
}
